<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="previewModal"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="manualPagination"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div>
          <slot />
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  props: {
    filename: {
      type: String,
      default: 'pdf_sample',
    },
    previewModal: {
      type: Boolean,
    },
    manualPagination: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    beforeDownload(event) {
      this.$emit('beforeDownload', event);
    },
    hasDownloaded() {
      this.$emit('hasDownloaded');
    },
  },
  components: {
    VueHtml2pdf,
  },
};
</script>
<style></style>
